import { createAction, props } from '@ngrx/store';

export const LOAD_GROUPLIST = '[Group List] Load Group List';
export const LOAD_GROUPLIST_SUCCESS = '[Group List] Load Group List Success';
export const LOAD_GROUPLIST_FAILURE = '[Group List] Load Group List Failure';

export const loadGroupList = createAction(LOAD_GROUPLIST);

export const loadGroupListSuccess = createAction(
  LOAD_GROUPLIST_SUCCESS,
  props<{ groups: any[] }>()
);

export const loadGroupListFailure = createAction(
  LOAD_GROUPLIST_FAILURE,
  props<{ error: any }>()
);
